import { useAuthContext } from 'components/auth'
import { useMutation } from '@tanstack/react-query'
import {
  removePositionTutorial,
  RemovePositionTutorialRequest,
} from 'api/company'

type MutationPayload = Pick<RemovePositionTutorialRequest, 'tutorialId'>
export function useRemovePositionTutorialMutation(options: {
  positionId: number
  onSuccess?: () => void
  onError?: (error: Error) => void
}) {
  const { positionId, onSuccess, onError } = options
  const companyId = useAuthContext().company?.id as number
  return useMutation({
    mutationFn: (request: MutationPayload) =>
      removePositionTutorial({ ...request, companyId, positionId }),
    onSuccess,
    onError,
  })
}
